import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=5e0d6d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0d6d84"]])

export default __exports__